import Vue from 'vue';
import store from './../../store';
import orderProductTransformer from './../../transformers/orderProduct';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const orderProducts = orderProductTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllOrderProducts', orderProducts);
  resolve(orderProducts);
};

const failed = () => {
};


export default (id, options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl(`/orders/${id}/products/search-order-product`, options))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/orderProduct/search.js